/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CapsulePartyDto } from '../../models/capsule-party-dto';

export interface MgmtCustomerControllerCapsuleSearch$Params {
  term: string;
}

export function mgmtCustomerControllerCapsuleSearch(http: HttpClient, rootUrl: string, params: MgmtCustomerControllerCapsuleSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CapsulePartyDto>>> {
  const rb = new RequestBuilder(rootUrl, mgmtCustomerControllerCapsuleSearch.PATH, 'get');
  if (params) {
    rb.query('term', params.term, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CapsulePartyDto>>;
    })
  );
}

mgmtCustomerControllerCapsuleSearch.PATH = '/api/mgmt-customers/capsule/search';
